<div class="wrapper">
  <div class="container px-0">
    <!--<h5 class="main-title fw-bold">{{practice_name}}</h5>-->
    <div class="pb-2">
      <h5 class="title fw-bold text-center mb-2 mt-2" style="font-size:21px"> {{'RegistrationPage.title' | translate}}</h5>
    </div>
    <div class="px-2 pb-3">
      <form [formGroup]="registrationForm">
        <div class="form-row">
          <div class="col-md-4 form-group">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.location.label' | translate}}<span class="text-danger">*</span></label>
              <div class="form-select ">
                <select translate="no"
                        style="font-size:20px !important;"
                        class="form-control custom-input border-0"
                        formControlName="location"
                        [ngStyle]="{'border' : getregistrationForm.location.invalid
                 && getregistrationForm.location.touched
                 && getregistrationForm.location.errors!.required
                 && !(providerLocation && providerLocation.length === 1) ? '1px solid red' : ''}"
                        (change)="onFocusOutLocation($event.target,'location')"
                        [disabled]="(providerLocation && providerLocation.length === 1) ? true : false">
                  <option value=""
                          [attr.selected]="(providerLocation && providerLocation.length > 1) ? true : null"
                          *ngIf="!(providerLocation && providerLocation.length === 1)">
                    {{'RegistrationPage.location.placeholder' | translate}}
                  </option>
                  <option *ngFor="let location of providerLocation"
                          [value]="location.locationCode"
                          [attr.selected]="(providerLocation && providerLocation.length === 1) ? true : null">
                    {{practice_code === '1013886' ? 'Westminster' : location.locationName }}
                  </option>
                </select>

              </div>


            </div>
            <div class="mb-2">
              <span *ngIf="getregistrationForm.location.invalid
                        && getregistrationForm.location.touched
                        && getregistrationForm.location.errors!.required
                        && !(providerLocation && providerLocation.length === 1)"
                    class="err">
                {{'RegistrationPage.location.error' | translate}}
              </span>
            </div>

          </div>
          <div class="col-md-4 form-group">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.firstname.label'|translate}}<span class="text-danger">*</span></label>

              <input style="font-size:20px !important;" type="text" class="form-control text-capitalize border-0 ltr-component" placeholder="{{'RegistrationPage.firstname.placeholder' | translate}}"
                     formControlName="firstname"
                     maxlength="35" (input)="ValidatePersonalInfo($event,'firstname')" />

            </div>
            <div class="mb-2">
              <span *ngIf="getregistrationForm.firstname.invalid && getregistrationForm.firstname.touched && getregistrationForm.firstname.errors!.required" class="err">
                {{'RegistrationPage.firstname.error' | translate}}
              </span>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.lastname.label'|translate}}<span class="text-danger">*</span></label>

              <input style="font-size:20px !important;" type="text" class="form-control text-capitalize border-0 ltr-component" placeholder="{{'RegistrationPage.lastname.placeholder' | translate}}" formControlName="lastname"
                     maxlength="35" (input)="ValidatePersonalInfo($event,'lastname')" />

            </div>
            <div class="mb-2">
              <span *ngIf="getregistrationForm.lastname.invalid && getregistrationForm.lastname.touched && getregistrationForm.lastname.errors!.required" class="err">
                {{'RegistrationPage.lastname.error' | translate}}
              </span>
            </div>

          </div>
          <div class="col-md-4 form-group"  id="relationship">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.gender.label'|translate}}<span class="text-danger">*</span></label>
              <div class="form-select ">
                <select style="font-size:20px !important;" translate="no" id="main_relationship" class="form-control custom-input border-0" formControlName="gender"  (change)="onFocusOutLocation($event.target,'gender')">
                  <option value="" disabled selected>{{'RegistrationPage.gender.placeholder' | translate}}</option>
                  <option value="Male">{{'RegistrationPage.gender.male' | translate}}</option>
                  <option value="Female">{{'RegistrationPage.gender.female' | translate}}</option>
                  <option value="Unknown">{{'RegistrationPage.gender.unknown' | translate}}</option>
                </select>

              </div>

            </div>
            <div class="mb-2">
              <span *ngIf="getregistrationForm.gender.invalid && getregistrationForm.gender.touched && getregistrationForm.gender.errors!.required" class="err"> {{'RegistrationPage.gender.error' | translate}}</span>
            </div>

          </div>
          <div class="col-md-4 form-group ">
            <div class="border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.dob.label'|translate}}<span class="text-danger">*</span></label>
              <div class="position-relative DateOfBirth">
                <mat-form-field autocomplete="off"
                                autocorrect="off"
                                autocapitalize="off" class="my-class">
                  <div class="input-container custom-input">
                    <input matInput placeholder="mm/dd/yyyy" [matDatepicker]="picker"
                           (click)="picker.open()" class="form-control custom-border"
                           value="" (focusout)="focusOutFunction($event, 0)"
                           formControlName="dob"
                           [max]="maxDate"
                           style="
                                font-size: 16px !important;
                                color:#929292 !important;
                                height:46px !important;
                                padding-left: 6px !important;"
                           autocomplete="off"
                           autocorrect="off"
                           autocapitalize="off"
                           readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker">
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker [format]="'yyyy-MM-dd'" disabled="false">
                    </mat-datepicker>
                    <span class="material-symbols-outlined" (click)="picker.open()">
                      calendar_month
                    </span>
                  </div>
                </mat-form-field>

              </div>

            </div>

            <div class="mb-2" *ngIf="getregistrationForm.dob.invalid">
              <span *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.required" class="err">
                {{'RegistrationPage.dob.required' | translate}}
              </span>
              <span class="err" *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.maxDate">{{'RegistrationPage.dob.error' | translate}}</span>
            </div>
          </div>

          <!--<div class="col-md-4">
    <div class=" position-relative  mb-2 border-bottom">
      <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.dob.label'|translate}}<span class="text-danger">*</span></label>
      <input type="date" class="form-control border-0" value="{{'insurances.insurances_subscriber_enter_dob'|translate}}" placeholder="Date of Birth"
             [max]="maxDate" formControlName="dob"
             min="{{'1901-01-01' | date:'yyyy-MM-dd'}}" (focusout)="focusOutFunction($event, 0)">
    </div>
    <div class="mb-2">
      <span *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.required" class="err">
        {{'RegistrationPage.dob.required' | translate}}
      </span>
      <span class="err" *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.maxDate">{{'RegistrationPage.dob.error' | translate}}</span>
    </div>
  </div>-->
          <div class="col-md-4 form-group">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.email.label'|translate}}<span class="text-danger" *ngIf="practice_code != '2410007'">*</span></label>
              <input style="font-size:20px !important;" type="email" placeholder="{{'RegistrationPage.email.placeholder' | translate}}" class="form-control custom-input border-0 ltr-component" formControlName="email" [ngStyle]="{'border' : !isValidEmail ? '1px solid red' : ''}"
                     (input)="validateEmailAddress($event.target)" />
            </div>
            <div class="mb-2">
              <span class="err" *ngIf="getregistrationForm.email.invalid && getregistrationForm.email.touched && getregistrationForm.email.errors!.required && practice_code != '2410007'">
                {{ 'RegistrationPage.email.required' | translate }}
              </span>
              <span *ngIf="!isValidEmail" class="err">{{'RegistrationPage.email.error' | translate}}</span>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 form-group">
            <div class=" border-bottom mb-2">
              <label style="font-size:20px;" class="fw-bold"> {{'RegistrationPage.cell.label'|translate}}<span class="text-danger">*</span></label>
              <div class="position-relative codeverified">
                <input style="font-size:20px !important;" type="text" placeholder="{{'RegistrationPage.cell.placeholder' | translate}}" class="form-control custom-input border-0 ltr-component" formControlName="cell"
                       (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')"
                       maxlength="14" />
                <!--<label class="EigtheenInchesFontSize" [ngClass]="getregistrationForm.cell.invalid && getregistrationForm.cell.touched && getregistrationForm.cell.errors!.required ? 'text-danger' : ''">{{'RegistrationPage.cell.label' | translate}} <span class="text-danger">*</span> </label>-->
              </div>

            </div>
            <div class="mb-2">
              <span *ngIf="isNotValidPhone" class="err">{{'RegistrationPage.cell.error' | translate}}</span>
              <span *ngIf="getregistrationForm.cell.invalid && getregistrationForm.cell.touched && getregistrationForm.cell.errors!.required" class="err">{{'RegistrationPage.cell.required' | translate}}</span>
            </div>

          </div>

          <!--smarty street-->
          <div class="col-md-4 col-lg-6 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.address'|translate}}<span class="text-danger">*</span></label>
              <div class="dropdown" ngbDropdown #addressDrop="ngbDropdown">
                <input placeholder="{{'updateinfo.address_placeholder'|translate}}" class="form-control text-left text-capitalize border-0 ltr-component" type="text"
                       ngbDropdownAnchor (focus)="addressDrop.open()" id="searchlanguagedropdown" aria-haspopup="true" aria-expanded="false"
                       formControlName="address" (input)="ValidateAddress($event.target,'address')"
                       (input)="SearchAdressBySmartyAPi($event)" autocomplete="off">

                <div ngbDropdownMenu class="custom-menu" aria-labelledby="searchaddressdropdown" [ngClass]="{'d-none': dNoneAddress}">
                  <button ngbDropdownItem *ngIf="isLoading">
                    {{'updateinfo.language_loading'|translate}}
                  </button>
                  <!--<button ngbDropdownItem *ngIf="!isLoading && !addressOptions">
            {{'updateinfo.language_search'|translate}}
          </button>-->
                  <button *ngIf="addressOptions?.length == 0 && !isLoading" ngbDropdownItem>
                    {{'updateinfo.language_no_records_found'|translate}}
                  </button>
                  <button ngbDropdownItem *ngFor="let address of addressOptions"
                          (click)="setAddressOption(address)">

                    {{ address.entries && address.entries > 1 ? address.streetLine + ' ' + address.secondary + '... ' +  address.city + ', ' + address.state + ' ' +  address.zipcode + " ( +" + address.entries + " addresses )" : address.streetLine + (address.secondary ? ' ' + address.secondary : '') + ' ' + address.city + ', ' +  address.state + ' ' +  address.zipcode }}

                  </button>
                </div>
              </div>

            </div>
            <div>
              <span class="err" id="c-address-line1-err" *ngIf="getregistrationForm.address.invalid && getregistrationForm.address.touched && getregistrationForm.address.errors!.required">
                {{'updateinfo.address_error_message'|translate}}
              </span>
            </div>

          </div>

          <div class="col-4 col-md-3 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.zip'|translate}}<span class="text-danger">*</span></label>
              <input type="text" placeholder="{{'updateinfo.zip_placeholder'|translate}}" (input)="onFocusOutZIPFinancial($event.target,0)" maxlength="10"
                     autocomplete="off" formControlName="zip" class="form-control border-0 ltr-component">
            </div>
            <div>
              <span class="err" id="f-zip-err" *ngIf="isZipCodeNotValidFinancialInfo">
                {{'updateinfo.enter_valid_zip_code'|translate}}
              </span>
              <span class="err" id="f-zip-err" *ngIf="!isZipCodeNotValidFinancialInfo && getregistrationForm.zip.invalid && getregistrationForm.zip.touched && getregistrationForm.zip.errors!.required">
                {{'updateinfo.enter_zip_code'|translate}}
              </span>
            </div>
          </div>
          <div class="col-8 col-md-3 col-lg-3 pb-2">
            <div class="form-group form-select mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.city'|translate}}</label>
              <select class="form-control text-capitalize border-0" (change)="onFocusOutCity($event.target )"
                      formControlName="city">

                <option *ngFor="let city of _cityandstate" [value]="city.cityName">
                  {{city.cityName | lowercase}}
                </option>
              </select>

            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-3 pb-2">
            <div class="form-group mb-2 border-bottom">
              <label class="form-label padding-left fw-bold"> {{'updateinfo.state'|translate}}</label>
              <input type="text" placeholder="State" formControlName="state" class="form-control border-0">

            </div>
          </div>

          <!--comment by sir Adeel Server-->
          <!--<div class="col-md-12">
    <a class="btn btn-primary" type="button" *ngIf="isShowVerifyButton && !verifiedCellPhone" data-target="#verifycode" (click)="SendOTP()">Verify Cell Phone</a>
  </div>
  <div *ngIf="verifiedCellPhone" type="text" style="color: green;" > &#10003; Verified Cell Phone</div>-->
        </div>
      </form>
    </div>
  </div>
</div>

<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <a class="btn btn-outline-primary" type="button" (click)="backPage()">{{'button.back'|translate}}</a>
      <a class="btn btn-primary" type="button" (click)="RegistorPatient()">{{'button.next'|translate}}</a>
    </div>
  </div>
</footer>

<!-- two factor auth modal  -->
<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="verifycode">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'RegistrationPage.verifycode_modal.title' | translate}}</h5>
        <button type="button" (click)="clearTimer()" class="close" data-dismiss="modal" aria-label="Close"> <span aria-hidden="true">&times;</span> </button>
      </div>
      <div class="modal-body">
        <p class="mb-2">{{'RegistrationPage.verifycode_modal.otp_message1' | translate}} {{linkType}} {{phoneLink}}. {{'RegistrationPage.verifycode_modal.otp_message2' | translate}}</p>
        <div class="align-items-center d-flex verifycode">
          <div class="form-group mb-0">
            <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" 
            [config]="{allowNumbersOnly: true, length: 4, isPasswordInput:false, 
              disableAutoFocus: false, placeholder: '', letterCase: 'Upper'}" id="ngotp">
            </ng-otp-input>
          </div> 
        </div> 
        <div *ngIf="!otpEntered" class="err">
          <span style="color: red;">{{'RegistrationPage.verifycode_modal.otp_required' | translate}}</span>
        </div>

        <div *ngIf="InvalidOTP" class="err">
          <span style="color: red; font-size: large;">{{'RegistrationPage.verifycode_modal.otp_invalid' | translate}}.</span>
          </div>

      </div>
      <div class="modal-footer">
        <span class="text-center mr-auto">&nbsp; {{'RegistrationPage.verifycode_modal.resend_timer' | translate}} {{m}}:{{s}}</span> 
        <button type="button" [disabled]="remainingTime > 0" [ngClass]="remainingTime == 0 ? 'btn btn-outline-primary btn-sm' : 'btn btn-secondary btn-sm'" (click)="SendOTP()">{{'RegistrationPage.verifycode_modal.resend_button' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="confirmModal">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-2 text-danger">{{'RegistrationPage.confirmModal.message' | translate}}</h5>
        <button type="button" aria-label="Close" class="btn btn-outline-primary mr-2" data-dismiss="modal">{{'button.no'|translate}}</button>
        <button type="button" data-toggle="modal" data-dismiss="modal" class="btn btn-primary rbtn"
        (click)="confirmBack()">{{'button.yes'|translate}}</button>
      </div>
    </div>
  </div>
</div>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse"  id="isNotValid_link">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong> {{'RegistrationPage.invalidLinkModal.title' | translate}}</strong></h5> 
        <p class="mb-3">{{'RegistrationPage.invalidLinkModal.message' | translate}}</p> 
      </div>
    </div>
  </div>
</div> 
